/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    number, string, array, func, arrayOf, shape,
} from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import getSiteConfig from '../../../utils/getSiteConfig';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';

const { PERSIST_KEY } = configENV;

class DesktopAddressRemove extends React.PureComponent {
    confirmationMessage = (addressType) => (
        addressType !== 'GIFT_LIST' ? (
            <>
                <p>Are you sure you want to </p><p>delete this address?</p>
            </>
        ) : (
            <>
                <p className="bodySize left">This recipient will be removed from this Gift List but will still appear in other Gift Lists and your Address Book</p>
                <p className="bodySize left">To remove them permanently, please contact Customer Service <br /> {getSiteConfig('phoneNumber')}</p>
            </>
        )
    );

    render() {
        const {
            AddressId,
            addressType,
            currentPage,
            recipient,
            recipientsByPage,
            handleCloseModal,
            handleSubmitRemoveRecipient,
        } = this.props;
        return (
            <>
                {this.confirmationMessage(addressType)}
                <div className="desktop-dialog-btn-wrapper">
                    <Button
                        onClick={() => handleCloseModal()}
                        variant="contained"
                        className="secondary margin-right-2x"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => handleSubmitRemoveRecipient(
                            recipient.AddressBookEntryId,
                            AddressId,
                            recipient,
                            addressType,
                            currentPage,
                            recipientsByPage,
                        )}
                        variant="contained"
                        color="primary"
                        className="red"
                    >
                        Delete
                    </Button>
                </div>
            </>
        );
    }
}

DesktopAddressRemove.defaultProps = {
    AddressId: -1,
    currentPage: -1,
    recipientsByPage: [],
};

DesktopAddressRemove.propTypes = {
    AddressId: number,
    currentPage: number,
    addressType: string.isRequired,
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        FirstName: string,
        LastName: string,
        RelationShip: string,
        NickName: string,
        LastUpdateDate: string,
        EmployerName: string,
        NumberOfAddresses: number,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                ContactId: number,
            }),
        ),
    }).isRequired,
    recipientsByPage: array, // An empty array for now; it reserves for pagination feature
    handleCloseModal: func.isRequired,
    handleSubmitRemoveRecipient: func.isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        AddressId: newState.AddressId,
        recipient: newState.recipient,
        addressType: newState.addressType,
        currentPage: newState.giftList.currentPage,
        recipientsByPage: newState.giftList.recipientsByPage,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleCloseModal: () => dispatch(EventDispatcher.handleCloseModal()),
    handleSubmitRemoveRecipient: (AddressBookEntryId, AddressId, recipient, addressType, currentPage, recipientsByPage) => dispatch(EventDispatcher.handleSubmitRemoveRecipient(
        AddressBookEntryId,
        AddressId,
        recipient,
        addressType,
        currentPage,
        recipientsByPage,
    )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DesktopAddressRemove);
